export const SET_USER = 'SET_USER';
export const LOWER_CREDIT = 'LOWER_CREDIT';
export const SHOW_OBJECT = 'SHOW_OBJECT';